import UploadPalmPhoto from 'templates-page/upload-palm-photo'

export const PalmUpload = () => {
  return <UploadPalmPhoto />
}
